var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"font-effra-light label"},[_vm._v(_vm._s(_vm.label))]),_c('p',{staticClass:"font-gilroy value",class:_vm.state},[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }